/* eslint-disable no-unused-vars */
import { ComponentType } from 'react';
//@ts-ignore
import SubscriptionIcon from './assets/img/subscription.svg';
//@ts-ignore
import BillingPaymentIcon from './assets/img/billing-payment.svg';
//@ts-ignore
import BillingCycleIcon from './assets/img/billing-cycle.svg';
//@ts-ignore
import EmailIcon from './assets/img/email.svg';
//@ts-ignore
import AvatarIcon from './assets/img/avatar-circle-icon.svg';

export enum SummaryPanelIcon {
  SUBSCRIPTION_ICON = 'SUBSCRIPTION_ICON',
  BILLING_PAYMENT_ICON = 'BILLING_PAYMENT_ICON',
  BILLING_CYCLE_ICON = 'BILLING_CYCLE_ICON',
  EMAIL_ICON = 'EMAIL_ICON',
  AVATAR_ICON = 'AVATAR_ICON',
}

const summaryPanelImageMapping: Record<string, ComponentType<{ [svgProp: string]: any }>> = {
  [SummaryPanelIcon.SUBSCRIPTION_ICON]: SubscriptionIcon,
  [SummaryPanelIcon.BILLING_PAYMENT_ICON]: BillingPaymentIcon,
  [SummaryPanelIcon.BILLING_CYCLE_ICON]: BillingCycleIcon,
  [SummaryPanelIcon.EMAIL_ICON]: EmailIcon,
  [SummaryPanelIcon.AVATAR_ICON]: AvatarIcon,
};

export const getSummaryPanelIcon: any = (iconKey: string) => {
  return summaryPanelImageMapping[iconKey] || '';
};
